import React, {useState} from 'react';
import {Row, Col, Collapse} from 'reactstrap'

const Footer = () =>{

    const [displayFooter, setDisplayFooter] = useState(false)
    const [displayDevs, setDisplayDevs] = useState(false)
    const [displayPartners, setDisplayPartners] = useState(false)
    
    const handleDisplayFooter = ()=>{setDisplayFooter(! displayFooter); setDisplayPartners(false); setDisplayDevs(false)}
    const handleDisplayDevs = ()=>{setDisplayDevs(! displayDevs); setDisplayPartners(false)}
    const handleDisplayPartners = ()=>{setDisplayPartners(! displayPartners); setDisplayDevs(false)}
    

    return(
        <footer>
{/* LE FOOTER SE LIT DE BAS EN HAUT PAR TRANCHE DE COLLAPSE (3etages au total) */}
                <Collapse className="footerRow3" id="RowPartners" isOpen={displayPartners}>
                    <Row>
                        <Col sm="2">
                            <a href="https://exploration.destination-orbite.net/actualite/index.php">Actualité de l'ISS</a>
                        </Col>

                        <Col sm="2">
                            <a href="https://www.facebook.com/ISS">Facebook</a>
                        </Col>
                        
                        <Col sm="2">
                            <a href="https://blogs.nasa.gov/spacestation/">NASA Blog</a>
                        </Col>

                        <Col sm="2">
                            <a href="https://twitter.com/ISS_Research">Twitter ISS Research</a>
                        </Col>
                    </Row>
                </Collapse>
                
                <Collapse id="footerRow3" isOPen={displayDevs}>
                    <Col tag="button" md="12" id="footerSeparator"></Col>
                </Collapse>
                
                <Collapse isOpen={displayDevs}>

                    <Row className="footerRow3" id="rowDev">
                    <Col md="2" className="colDev">
                        <div>Alexis ARCHER</div>
                        <div>07.61.29.72.72</div>
                        <div class="contactIcons"><a><img alt="Icon for contact" src="https://upload.wikimedia.org/wikipedia/commons/5/52/Mail_iOS.svg"></img></a> <a href="https://www.linkedin.com/in/alexis-archer-151179138/"><img alt="icon for contact"  src="https://blog.neocamino.com/wp-content/uploads/2013/08/linkedin-1-300x300.png"></img></a> </div>
                    </Col>
                    
                    <Col md="2" className="colDev"> 
                        <div>Ornella GRISTI</div>
                        <div>06.40.14.75.49</div>
                        <div class="contactIcons"><a href="mailto:Ornellazaidi@gmail.com"><img alt=""  src="https://upload.wikimedia.org/wikipedia/commons/5/52/Mail_iOS.svg"></img></a> <a href="https://www.linkedin.com/in/ornella-gristi-5923159b/"><img alt=""  src="https://blog.neocamino.com/wp-content/uploads/2013/08/linkedin-1-300x300.png"></img></a> </div>
                    
                    </Col>
                    
                    <Col md="2" className="colDev"> 
                        <div>Florian PLOT</div>
                        <div>06.35.37.79.06</div>
                        <div class="contactIcons"><a href="mailto:flouuxi26@gmail.com" ><img alt=""  src="https://upload.wikimedia.org/wikipedia/commons/5/52/Mail_iOS.svg"></img></a> <a href="https://www.linkedin.com/in/florian-plot/"><img alt=""  src="https://blog.neocamino.com/wp-content/uploads/2013/08/linkedin-1-300x300.png"></img></a> </div>
                    </Col>
                    
                    <Col md="2" className="colDev"> 
                        <div>Dylan BERTHIER</div>
                        <div>06.38.50.82.93</div>
                        <div class="contactIcons"><a href="mailto:dylan.berthier13@gmail.Com"><img alt=""  src="https://upload.wikimedia.org/wikipedia/commons/5/52/Mail_iOS.svg"></img></a> <a href="https://www.linkedin.com/in/dylan-berthier/"><img alt=""  src="https://blog.neocamino.com/wp-content/uploads/2013/08/linkedin-1-300x300.png"></img></a> </div>
                    </Col>
                    
                    <Col md="2" className="colDev"> 
                        <div>Marie Gory</div>
                        <div>06.82.80.80.64</div>
                        <div class="contactIcons"><a href="mailto:marie.gory@gmail.Com"><img alt=""  src="https://upload.wikimedia.org/wikipedia/commons/5/52/Mail_iOS.svg"></img></a> <a href="https://www.linkedin.com/in/marie-gory/"><img alt=""  src="https://blog.neocamino.com/wp-content/uploads/2013/08/linkedin-1-300x300.png"></img></a> </div>
                    </Col>
                </Row>
            
                </Collapse>


                <Collapse id="footerRow2" isOpen={displayFooter}>
                    <button 
                            onClick={()=>handleDisplayDevs()}
                            className="buttonFooter">
                                Get in touch with the crew
                        </button >
                        <button 
                        onClick={()=>handleDisplayPartners()}
                        className="buttonFooter">Our website partners</button>
                    
                </Collapse >


            <Row id="footerRow1">
            <button onClick={()=>{handleDisplayFooter()}}>More informations</button>
            </Row>



        </footer>
    )
}

export default Footer